module.exports = __webpack_public_path__ + "img/budget.e2a9eeb9.svg";